import { useCallback, useRef, useState } from 'react';

export interface FileDownloadResult {
  data: Blob;
  filename: string;
}

export function useFileDownload() {
  const anchorRef = useRef<HTMLAnchorElement>(null);
  const [downloading, setDownloading] = useState(false);

  const download = useCallback(async (fetchFile: () => Promise<FileDownloadResult>) => {
    setDownloading(true);
    try {
      const { data, filename } = await fetchFile();
      const objectUrl = URL.createObjectURL(data);
      if (anchorRef.current) {
        anchorRef.current.href = objectUrl;
        anchorRef.current.download = filename;
        anchorRef.current.click();
      }
      URL.revokeObjectURL(objectUrl);
    } finally {
      setDownloading(false);
    }
  }, []);

  return { download, downloading, anchorRef };
}
